import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { ProductItem } from "../../../ProductItem/modules/SelectionModal/components/ProductItem/ProductItem.js";
import { ProductItemLoading } from "../../../ProductItem/modules/SelectionModal/components/ProductItem/ProductItemLoading.js";
import { ProductItemNotFound } from "../../../ProductItem/modules/SelectionModal/components/ProductItem/ProductItemNotFound.js";
const ProductItemContainer = ({ product, onRemove }) => {
  const { sku } = product;
  const { getLabel } = useIntl();
  const labels = {
    item: {
      remove: getLabel("tryInStore.component.selectionModal.productItem.remove")
    },
    itemLoading: {
      title: getLabel("tryInStore.component.selectionModal.productItemLoading.title"),
      imageAlt: getLabel("tryInStore.component.selectionModal.productItemLoading.imageAlt")
    },
    itemNotFound: {
      notFound: getLabel("tryInStore.component.selectionModal.productItemNotFound.title"),
      remove: getLabel("tryInStore.component.selectionModal.productItem.remove"),
      imageAlt: getLabel("tryInStore.component.selectionModal.productItemNotFound.imageAlt")
    }
  };
  const handleRemove = React.useCallback(() => {
    onRemove(sku);
  }, [onRemove, sku]);
  if (product.__itemType === "notFound") {
    return /* @__PURE__ */ React.createElement(ProductItemNotFound, { product, onRemove: handleRemove, labels: labels.itemNotFound });
  }
  if (product.__itemType === "product") {
    return /* @__PURE__ */ React.createElement(ProductItem, { product, onRemove: handleRemove, labels: labels.item });
  }
  return /* @__PURE__ */ React.createElement(ProductItemLoading, { product, labels: labels.itemLoading });
};
export {
  ProductItemContainer
};
//# sourceMappingURL=ProductItemContainer.js.map
